module.exports = "images/apple-icon-144x144.6ee944d9593932d3920b739e34854687.png";